import React, { useEffect, useState } from "react";
import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";
import Badge from "../../../../Component/Common/Badge";
import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";
import { BASE_URL } from "../../../../config/api";
import axios from "axios";

export default function RetailerDetailPanel({ retailer }) {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(false);

  // 🔥 FETCH COUNTS WHEN RETAILER CHANGES
  useEffect(() => {

    if (!retailer?.id) return;

    const fetchAnalytics = async () => {

      try {

        setLoading(true);

        const response =
          await axios.get(
            `${BASE_URL}warranty/sale-records`,
            {
              params: {
                retailer_id:
                  retailer.id,
              },

              headers: {
                Accept:
                  "application/json",

                "Content-Type":
                  "application/json",
              },
            }
          );

        const json =
          response.data;

        setAnalytics(
          json?.analytics || null
        );

      } catch (err) {

        console.error(
          "Failed to fetch retailer analytics",
          err
        );

        setAnalytics(null);

      } finally {

        setLoading(false);

      }
    };

    fetchAnalytics();

  }, [retailer?.id]);

  // ---------------- EMPTY STATE ----------------
  if (!retailer) {
    return (
      <SectionCard title="ARP Details">
        <div className="text-xs text-slate-500">
          Select a ARP from the list to view commission details.
        </div>
      </SectionCard>
    );
  }

  // ---------------- LOADING STATE ----------------
  if (loading) {
    return (
      <SectionCard title="ARP Details">
        <div className="text-xs text-slate-500">Loading analytics…</div>
      </SectionCard>
    );
  }

  const {
    total_devices = 0,
    total_product_price = 0,
    retailer_payout = 0,
    company_payout = 0,
  } = analytics || {};

  return (
    <SectionCard
      title="ARP Details"
      right={
        <Badge
          label={retailer.is_payment_success === 1 ? "Selling" : "Not Selling"}
          color={retailer.is_payment_success === 1 ? "green" : "gray"}
        />
      }
    >
      <div className="space-y-3 text-xs">
        {/* ---------- BASIC INFO ---------- */}
        <div>
          <div className="font-semibold text-slate-800">
            {retailer.business_name || retailer.contact_person}
          </div>
          <div className="text-[11px] text-slate-500">
            {retailer.city} · Code: RT-{retailer.id}
          </div>
          <div className="text-[11px] text-slate-500">
            Onboarded on{" "}
            <span className="font-medium text-slate-700">
              {retailer.created_at?.split("T")[0]}
            </span>
          </div>
        </div>

        {/* ---------- KPI CARDS ---------- */}
        <div className="grid grid-cols-2 gap-2">
          <KpiCard
            label="Total Devices Sold"
            value={total_devices.toLocaleString()}
          />
          <KpiCard
            label="Total Product Value"
            value={`₹${total_product_price.toLocaleString()}`}
          />
          {/* <KpiCard
            label="Retailer Commission"
            value={`₹${retailer_payout.toLocaleString()}`}
          />
          <KpiCard
            label="Company Share"
            value={`₹${company_payout.toLocaleString()}`}
          /> */}
        </div>

        {/* ---------- ACTIONS ---------- */}
        <div className="flex flex-wrap gap-2 pt-1">
          <button className="text-[11px] px-2 py-1 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100">
            View statement
          </button>
          <button className="text-[11px] px-2 py-1 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100">
            Download statement
          </button>
        </div>
      </div>
    </SectionCard>
  );
}



// import react from "react";
// import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";
// import { Badge } from "../../../../Component/AgentComponents/Badge";
// import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";

// export default function RetailerDetailPanel({ retailer, allRetailers }) {
//   if (!retailer) {
//     return (
//       <SectionCard title="Retailer Details">
//         <div className="text-xs text-slate-500">
//           Select a retailer from the list to view commission details.
//         </div>
//       </SectionCard>
//     );
//   }

//   const effectiveRate = (retailer.commissionRate || 0) * 100;

//   return (
//     <SectionCard
//       title="Retailer Details"
//       right={
//         <Badge color={retailer.isSelling ? "green" : "yellow"}>
//           {retailer.isSelling ? "Selling" : "Not selling"}
//         </Badge>
//       }
//     >
//       <div className="space-y-3 text-xs">
//         <div>
//           <div className="font-semibold text-slate-800">{retailer.name}</div>
//           <div className="text-[11px] text-slate-500">
//             {retailer.city} · Code: {retailer.code}
//           </div>
//           <div className="text-[11px] text-slate-500">
//             Onboarded on{" "}
//             <span className="font-medium text-slate-700">
//               {retailer.onboardDate}
//             </span>
//           </div>
//         </div>

//         <div className="grid grid-cols-2 gap-2">
//           <KpiCard
//             label="This Month Sales"
//             value={`₹${(retailer.monthlySales || 0).toLocaleString()}`}
//           />
//           <KpiCard
//             label="This Month Comm."
//             value={`₹${(retailer.monthCommission || 0).toLocaleString()}`}
//             subLabel={`Rate: ${effectiveRate.toFixed(1)}%`}
//           />
//           <KpiCard
//             label="Lifetime Sales"
//             value={`₹${(retailer.totalSales || 0).toLocaleString()}`}
//           />
//           <KpiCard
//             label="Lifetime Comm."
//             value={`₹${(retailer.totalCommission || 0).toLocaleString()}`}
//           />
//         </div>

//         <div className="flex flex-wrap gap-2 pt-1">
//           <button className="text-[11px] px-2 py-1 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100">
//             View statement
//           </button>
//           <button className="text-[11px] px-2 py-1 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100">
//             Download statement
//           </button>
//         </div>

//         <div className="text-[11px] text-slate-500">
//           Hint: Plan{" "}
//           <span className="font-semibold text-blue-700">activation call</span>{" "}
//           or{" "}
//           <span className="font-semibold text-blue-700">training session</span>{" "}
//           if sales are low or retailer is not selling.
//         </div>
//       </div>
//     </SectionCard>
//   );
// }